// src/components/Navigation.tsx

import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, LogOut } from 'lucide-react'; // İkonlar
import { Button } from './ui/button.tsx';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
  SheetDescription,
} from './ui/sheet.tsx';

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Token kontrolü
  const token = localStorage.getItem('access');
  const isLoggedIn = !!token;

  // Konsola bilgi basalım (Test için)
  console.log("Token:", token);
  console.log("Giriş Durumu:", isLoggedIn);

  // Linkler
  const navItems = [
    { path: '/', label: 'Anasayfa' },
    { path: '/uyelik', label: 'Üyelik', guestOnly: true }, // Sadece Misafire
    { path: '/etkinlikler', label: 'Etkinlikler', authOnly: true }, // Sadece Üyeye
    { path: '/duyurular', label: 'Duyurular', authOnly: true }, // GÜNCELLENDİ: Sadece Üyeye
    { path: '/mezun-agi', label: 'Mezun Ağı', authOnly: true }, // Sadece Üyeye
    { path: '/galeri', label: 'Galeri', authOnly: true }, // GÜNCELLENDİ: Sadece Üyeye
    { path: '/iletisim', label: 'İletişim' },
  ];

  // FİLTRELEME
  const filteredNavItems = navItems.filter((item) => {
    if (item.guestOnly && isLoggedIn) return false;
    if (item.authOnly && !isLoggedIn) return false;
    return true;
  });

  // Çıkış Yap Fonksiyonu
  const handleLogout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    window.location.href = '/'; 
  };

  // Aktif sayfa kontrolü
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bg-gradient-to-r bg-[#A8322D] text-white sticky top-0 z-40">
      <div className="container mx-auto px-4">
        
        {/* --- DESKTOP NAVIGATION --- */}
        <div className="hidden lg:flex items-center justify-between">
            
            {/* Linkler Grubu */}
            <div className="flex items-center gap-1">
                {filteredNavItems.map((item) => (
                    <Link
                    key={item.path}
                    to={item.path}
                    className={`px-4 py-3 hover:bg-white/20 transition-colors ${
                        isActive(item.path) ? 'bg-white/20' : ''
                    }`}
                    >
                    {item.label}
                    </Link>
                ))}
            </div>
        </div>

        {/* --- MOBILE NAVIGATION --- */}
        <div className="lg:hidden py-3 flex justify-between items-center">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="sm" className="text-white hover:bg-white/20">
                <Menu className="h-5 w-5 mr-2" />
                Menü
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-64 bg-white">
              <SheetTitle className="sr-only">Navigasyon</SheetTitle>
              <SheetDescription className="sr-only">Menü linkleri</SheetDescription>
              
              <div className="flex flex-col gap-2 mt-8">
                {/* Mobil Linkler */}
                {filteredNavItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`px-6 py-5 text-left rounded hover:bg-slate-100 transition-colors ${
                      isActive(item.path) ? 'bg-orange-100 text-orange-900' : ''
                    }`}
                  >
                    {item.label}
                  </Link>
                ))}

                {/* Mobil Çıkış Butonu */}
                {isLoggedIn && (
                  <button 
                    onClick={handleLogout}
                    className="px-6 py-5 text-left rounded text-red-600 hover:bg-red-50 transition-colors font-semibold flex items-center"
                  >
                    <LogOut className="mr-2 h-4 w-4" /> Çıkış Yap
                  </button>
                )}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}